import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")

import { ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import router from '@/router/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  emits: ['switchOrder'],
  setup(__props, { emit }) {

const {
  'POST/commission/users': fetchList,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  month: ""
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()



// 跳转订单或者成功
const switchPageHandle = (row: any, column: any) => {
  emit('switchOrder', row.commissionIds)
  // 订单本位币跳转定订单
  /* router.push({ 
    path: '/order-query', 
    query: {
      ids: row.commissionIds
    }
  }) */
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "searchEle",
      ref: searchEle,
      model: _unref(searchObj),
      "label-width": "auto",
      inline: "",
      class: "searchBg mb-10",
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "月份:",
          prop: "month"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(searchObj).month,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).month) = $event)),
              "value-format": "YYYY-MM-DD",
              type: "month",
              placeholder: "请选择月份",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (searchHandle()))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (searchHandle())),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (searchEle.value.resetFields()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "disabled"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      class: "mt-10",
      onRowDblclick: switchPageHandle,
      "max-height": _unref(MI_height) - 50 + 'px',
      style: {"width":"880px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Name",
          prop: "name",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      style: {"float":"none"},
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})